import React from 'react';
import './Pagination.css';

const Pagination = ({ pagination, onPageChange, t, compact = false }) => {
  const renderPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 5;
    let startPage = Math.max(1, pagination.current_page - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(pagination.total_pages, startPage + maxPagesToShow - 1);

    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    if (startPage > 1) {
      pages.push(
        <button key="first" onClick={() => onPageChange(1)} className="pagination-button">
          1
        </button>
      );
      if (startPage > 2) {
        pages.push(<span key="dots1" className="pagination-dots">...</span>);
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => onPageChange(i)}
          className={`pagination-button ${i === pagination.current_page ? 'active' : ''}`}
        >
          {i}
        </button>
      );
    }

    if (endPage < pagination.total_pages) {
      if (endPage < pagination.total_pages - 1) {
        pages.push(<span key="dots2" className="pagination-dots">...</span>);
      }
      pages.push(
        <button
          key="last"
          onClick={() => onPageChange(pagination.total_pages)}
          className="pagination-button"
        >
          {pagination.total_pages}
        </button>
      );
    }

    return pages;
  };

  if (pagination.total_pages <= 1) {
    return null;
  }

  return (
    <div className={`pagination${compact ? ' pagination--compact' : ''}`}>
      <button
        onClick={() => onPageChange(pagination.current_page - 1)}
        disabled={pagination.current_page === 1}
        className="pagination-button"
        aria-label={t('common.previous')}
      >
        {compact ? '‹' : t('common.previous')}
      </button>

      {renderPageNumbers()}

      <button
        onClick={() => onPageChange(pagination.current_page + 1)}
        disabled={pagination.current_page === pagination.total_pages}
        className="pagination-button"
        aria-label={t('common.next')}
      >
        {compact ? '›' : t('common.next')}
      </button>
    </div>
  );
};

export default Pagination;